import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ContainerForm } from './RegisterFormStyles';
import { Block, Text, Icon } from '../../../../../../../../components';
import Select from '../../../../../../components/Select';
import { SaveButton } from '@/presentation/modules/procedures/modules/scholarships/bse/components/styled';
import { RegisterFormProps, FormFields } from './RegisterForm.types';

const RegisterFormForm: React.FC<RegisterFormProps> = ({
  handleSubmit: onSubmit,
  onFieldsReady,
  options,
  availableTimeSlots
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isValid }
  } = useForm<FormFields>({ mode: 'onChange' });

  const detail = watch('detail', '');
  const contact = watch('contact', '');
  const detail2 = watch('detail2', '');
  const idDetail2 = watch('idDetail2', 0);
  const reason = watch('reason', '');

  useEffect(() => {
    const formEmpty = !reason && !contact && !detail && !detail2;
    onFieldsReady(!formEmpty);
  }, [detail, contact, detail2, idDetail2, reason, onFieldsReady]);

  const handleSelectChange = (selected: { value: string; label: string }) => {
    setValue('reason', selected.value, { shouldValidate: true });
  };
  const handleSelectChange2 = (selected: { value: string; label: string }) => {
    setValue('detail2', selected.label, { shouldValidate: true });
    setValue('idDetail2', selected.value, { shouldValidate: true });
  };

  const onFormSubmit = async (data: FormFields) => {
    onSubmit({
      detail: data.detail || '',
      contact: data.contact || '',
      detail2: data.detail2 || '',
      idDetail2: data.idDetail2 || 0,
      reason: data.reason
    });
  };

  useEffect(() => {
    register('reason', { required: 'El motivo es obligatorio' });
    register('detail2', { required: '' });
    register('idDetail2', { required: '' });
  }, [register]);

  return (
    <ContainerForm>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <Block
          customized
          padding="24px"
          backgroundColor="#fff"
          borderRadius="4px"
          margin="12px 0px 0px 0px"
        >
          {/* MOTIVO */}
          <Block customized margin="0px">
            <Text
              fontWeight="normal"
              fontSize="14px"
              lineHeight="20px"
              color="#161D1F"
            >
              Motivo
            </Text>
          </Block>
          <Block customized margin="4px 0px 0px">
            <Select
              options={options.map((item) => ({ value: item, label: item }))}
              placeholder="Selecciona un motivo"
              handleChangeSelect={handleSelectChange}
            />
          </Block>

          {/* DETALLE */}
          <Block customized margin="16px 0px 4px" padding="0 10px 0 0">
            <Text
              fontWeight="normal"
              fontSize="14px"
              lineHeight="20px"
              color="#161D1F"
            >
              Describe más detalle sobre tu solicitud
            </Text>
          </Block>
          <Block customized>
            <textarea
              name="detail"
              placeholder="Escribe aquí el detalle"
              ref={register({
                maxLength: {
                  value: 500,
                  message: 'Excediste el número de caracteres.'
                }
              })}
              style={{
                borderColor: errors.detail ? '#E8212B' : '#283044',
                borderWidth: '1px',
                borderStyle: 'solid'
              }}
            />
          </Block>

          <Block
            customized
            flexDirection="row"
            justifyContent="space-between"
            margin="4px 0px 0px"
          >
            <Block customized flexDirection="row" className="alert">
              {errors.detail && (
                <>
                  <Icon name="alert-triangle" size="16" />
                  <Text
                    fontWeight="normal"
                    fontSize="12px"
                    lineHeight="16px"
                    color="#E8212B"
                  >
                    {errors.detail.message}
                  </Text>
                </>
              )}
            </Block>

            <Block customized alignItems="flex-end" maxWidth="51px">
              <Text
                fontWeight="normal"
                fontSize="12px"
                lineHeight="16px"
                color={errors.detail ? '#E8212B' : '#283044'}
              >
                {detail.length} / 500
              </Text>
            </Block>
          </Block>

          {/* CONTACTO */}
          <Block customized margin="16px 0px 4px">
            <Text
              fontWeight="normal"
              fontSize="14px"
              lineHeight="20px"
              color="#161D1F"
            >
              Contacto
            </Text>
          </Block>
          <Block customized>
            <input
              type="number"
              name="contact"
              placeholder="Ingresa tu número telefónico"
              ref={register({
                maxLength: {
                  value: 11,
                  message: 'Excediste el número de caracteres.'
                },
                pattern: {
                  value: /^\d+$/,
                  message: 'Solo números son permitidos'
                }
              })}
              style={{
                borderColor: errors.contact ? '#E8212B' : '#283044',
                borderWidth: '1px',
                borderStyle: 'solid',
                MozAppearance: 'textfield'
              }}
              onWheel={(e) => e.currentTarget.blur()}
            />
            <style>{`
              input[type='number']::-webkit-outer-spin-button,
              input[type='number']::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
            `}</style>
          </Block>

          <Block
            customized
            flexDirection="row"
            justifyContent="space-between"
            margin="4px 0px 0px"
          >
            <Block customized flexDirection="row" className="alert">
              {errors.contact && (
                <>
                  <Icon name="alert-triangle" size="16" />
                  <Text
                    fontWeight="normal"
                    fontSize="12px"
                    lineHeight="16px"
                    color="#E8212B"
                  >
                    {errors.contact.message}
                  </Text>
                </>
              )}
            </Block>

            <Block customized alignItems="flex-end" maxWidth="51px">
              <Text
                fontWeight="normal"
                fontSize="12px"
                lineHeight="16px"
                color={errors.contact ? '#E8212B' : '#283044'}
              >
                {contact.length} / 11
              </Text>
            </Block>
          </Block>

          {/* DETALLE 2 (OPCIONAL) */}
          <Block customized margin="16px 0px 4px">
            <Text
              fontWeight="normal"
              fontSize="14px"
              lineHeight="20px"
              color="#161D1F"
            >
              Elige el rango horario para contactarte y validar tu solicitud
            </Text>
          </Block>
          <Block customized>
            <Select
              options={availableTimeSlots.map((item) => ({
                value: item.id,
                label: item.name
              }))}
              placeholder="Selecciona un horario"
              handleChangeSelect={handleSelectChange2}
            />
          </Block>

          <Block
            customized
            flexDirection="row"
            justifyContent="space-between"
            margin="4px 0px 0px"
          >
            <Block customized flexDirection="row" className="alert">
              {errors.detail2 && (
                <>
                  <Icon name="alert-triangle" size="16" />
                  <Text
                    fontWeight="normal"
                    fontSize="12px"
                    lineHeight="16px"
                    color="#E8212B"
                  >
                    {errors.detail2.message}
                  </Text>
                </>
              )}
            </Block>
          </Block>

          <SaveButton
            type="submit"
            style={{ marginTop: 24 }}
            data-testid="btn-register-retreatCourse"
            disabled={!isValid || !reason || !contact || !detail || !detail2}
          >
            Enviar solicitud
          </SaveButton>
        </Block>
      </form>
    </ContainerForm>
  );
};

export default RegisterFormForm;
